var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#DCFCE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 32C18.7333 32 16.5278 31.0944 14.7167 29.2833C12.9056 27.4722 12 25.2667 12 22.6667V14.6667C12 13.9333 12.2611 13.3056 12.7833 12.7833C13.3056 12.2611 13.9333 12 14.6667 12H31.3333C32.6222 12 33.7222 12.4556 34.6333 13.3667C35.5444 14.2778 36 15.3778 36 16.6667C36 17.9556 35.5444 19.0556 34.6333 19.9667C33.7222 20.8778 32.6222 21.3333 31.3333 21.3333H30.6667V22.6667C30.6667 25.2667 29.7611 27.4722 27.95 29.2833C26.1389 31.0944 23.9333 32 21.3333 32ZM14.6667 18.6667H28V14.6667H14.6667V18.6667ZM21.3333 29.3333C23.1778 29.3333 24.75 28.6833 26.05 27.3833C27.35 26.0833 28 24.5111 28 22.6667V21.3333H14.6667V22.6667C14.6667 24.5111 15.3167 26.0833 16.6167 27.3833C17.9167 28.6833 19.4889 29.3333 21.3333 29.3333ZM30.6667 18.6667H31.3333C31.8889 18.6667 32.3611 18.4722 32.75 18.0833C33.1389 17.6944 33.3333 17.2222 33.3333 16.6667C33.3333 16.1111 33.1389 15.6389 32.75 15.25C32.3611 14.8611 31.8889 14.6667 31.3333 14.6667H30.6667V18.6667ZM12 36V33.3333H33.3333V36H12Z",
    fill: "#16A34A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.e80f6d1aae692bd6564433a2a3a7d7d9.svg";
export { ForwardRef as ReactComponent };